import { render, staticRenderFns } from "./EditSettlement.vue?vue&type=template&id=56e676c9&scoped=true"
import script from "./EditSettlement.vue?vue&type=script&lang=js"
export * from "./EditSettlement.vue?vue&type=script&lang=js"
import style0 from "./EditSettlement.vue?vue&type=style&index=0&id=56e676c9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e676c9",
  null
  
)

export default component.exports